import React, { Component } from 'react';
import NavigationBar from "../components/navigationBar";
import AuthTokenService from "../service/authTokenService";

export default class Profile extends Component {

    constructor(props) {
        super(props);

        this.authTokenService = new AuthTokenService();

        this.state = {
            OldPassword: "",
            NewPassword: ""
        }
        this.handleChange = this.handleChange.bind(this);
        
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    async changePassword(event) {
        event.preventDefault();

        if(!this.state.NewPassword){
            return;
        }

        if(!this.state.OldPassword){
            return;
        }

        let results = await this.authTokenService.changeUserPassword(this.state.OldPassword, this.state.NewPassword);
        if (results.status === 401) {
            this.props.history.push("/Login");
        }
    }

    render() {
        return (
            <div className='body'>
                <NavigationBar {...this.props} />
                <main>
                    <div className="task-detail-container">
                        <div className="divWidth100">
                            <div className="task-detail-container-vertical">
                                <h1>Profile Page</h1>

                                <div>
                                    <h2>Change Password</h2>
                                    <form action="#" onSubmit={(event) => { this.changePassword(event) }}>
                                        <label className="labelLoginForm" htmlFor="OldPassword"><b>Old Password:</b></label><br />
                                        <input id="oldpassword" className="loginInputLabel" type="password" placeholder="Old Password" name="OldPassword" value={this.state.OldPassword} onChange={this.handleChange} required /><br />
                                        
                                        <label className="labelLoginForm" htmlFor="NewPassword"><b>New Password:</b></label><br />
                                        <input className="loginInputLabel" type="password" placeholder="New Password" name="NewPassword" value={this.state.NewPassword} onChange={this.handleChange} required /><br />

                                        <button className="buttonLoginSubmit" type="submit">Change Password</button>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    };

}



// WEBPACK FOOTER //
// ./src/sites/profile.js